import React from 'react'
import { Field } from 'redux-form'
import PropTypes from 'prop-types'
import { Col, Button, Label, Modal } from 'react-bootstrap'
import Form from 'components/Form'
import RadioField from 'components/RadioField'

class ViewStatus extends React.Component {

	constructor(props, context) {
		super(props, context)

		this.handleShow = this.handleShow.bind(this)
		this.handleClose = this.handleClose.bind(this)

		this.state = {
			show: false,
			successMsg: null
		}
	}

	handleClose() {
		this.setState({ show: false })
	}

	handleShow() {
		this.setState({ show: true })
	}

	render () {
		const { successMsg } = this.state
		const { onSubmit, data } = this.props
		return <Col xs={12} md={8}>

			<Modal show={this.state.show} onHide={this.handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>Confirmation</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>Are you sure you want to make this change?</p>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={this.handleClose}>Close</Button>
					<Button bsStyle="primary" onClick={() => onSubmit(data).then(() => {
						this.handleClose()
						this.setState({ successMsg: 'Successfully updated!' })
						setTimeout(() => {
							this.setState({ successMsg: null })
						}, 2000)
					})}>Save changes</Button>
				</Modal.Footer>
			</Modal>

			<h4>Danger Zone</h4>
			<p><Label bsStyle="warning">Warning!</Label></p>
			<p>If you switch off the game, the system will stop right away. If there is an allocations cycle in progress, it
				will be immediately completed and no winners will be picked.</p>
			<p>If you then switch on the system, the next allocations cycle will not start immediately, but on Monday, 10:00
				AM PT, as usual.</p>
			<Form shouldShowSuccessMessage {...this.props}>
				<Field
					id='turned-on'
					name='status'
					label='Turn on'
					component={RadioField}
					type='radio'
					value='TURNED_ON'
				/>
				<Field
					id='turned-off'
					name='status'
					label='Turn off'
					component={RadioField}
					type='radio'
					value='TURNED_OFF'
				/>
				<div className='mt mb'>
					<Button bsStyle='primary' onClick={this.handleShow}>Save</Button>
				</div>
				{ successMsg && <div className='text-success mt'>{successMsg}</div>}
			</Form>
		</Col>
	}
}

ViewStatus.propTypes = {
	onSubmit: PropTypes.func,
	data: PropTypes.object
}

export default ViewStatus




// WEBPACK FOOTER //
// ./src/routes/Settings/components/ViewStatus.js